export default "__VITE_ASSET__6DREr81p__"